import type { Components } from '@mui/material'

export const MENU_ITEM_HEIGHT = 48

const MuiMenuItem: Components['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      height: `${MENU_ITEM_HEIGHT}px`,
    },
  },
}

export default MuiMenuItem
